import Vue from 'vue'
import Router from 'vue-router'
import Wrong from '@/components/wrong'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      name: 'Wrong',
      component: Wrong
    },
    {
      path: '/',
      name: 'Index',
      meta: {
        title: '首页'
      },
      component: (resolve) => require(['@/view/index'], resolve)
    },
    {
      path: '/login/index',
      name: 'loginIndex',
      meta: {
        title: '登录'
      },
      component: (resolve) => require(['@/view/login/index'], resolve)
    },
    {
      path: '/login/login',
      name: 'Login',
      meta: {
        title: '登录'
      },
      component: (resolve) => require(['@/view/login/login'], resolve)
    },
    {
      path: '/login/bindLogin',
      name: 'BindLogin',
      meta: {
        title: '绑定'
      },
      component: (resolve) => require(['@/view/login/bindLogin'], resolve)
    },
    {
      path: '/login/resetPwd',
      name: 'ResetPwd',
      meta: {
        title: '重置密码'
      },
      component: (resolve) => require(['@/view/login/resetPwd'], resolve)
    },
    {
      path: '/login/userXieyi',
      name: 'UserXieyi',
      meta: {
        title: '用户协议'
      },
      component: (resolve) => require(['@/view/login/userXieyi'], resolve)
    },
    {
      path: '/rankingList/rankingList',
      name: 'rankingList',
      component: resolve => {
        return require(['../view/rankingList/rankingList'], resolve)
      },
      meta: {
        title: '排行',
        keepAlive: false,
        auth: false
      }
    },
    {
      path: '/rankExplain/rankExplain',
      name: 'rankExplain',
      component: resolve => {
        return require(['../view/rankExplain/rankExplain'], resolve)
      },
      meta: {
        title: '等级说明',
        keepAlive: true,
        auth: false
      }
    },
    {
      path: '/showImage/showImage',
      name: 'showImage',
      component: resolve => {
        return require(['../view/share/showImage/showImage'], resolve)
      },
      meta: {
        title: '晒图详情',
        keepAlive: true,
        auth: false
      }
    },
    {
      path: '/stamp/stamp',
      name: 'stamp',
      component: resolve => {
        return require(['../view/share/stamp/stamp'], resolve)
      },
      meta: {
        title: '邮册单票详情',
        keepAlive: false,
        auth: false
      }
    },
    {
      path: '/stamps/stamps',
      name: 'stamps',
      component: resolve => {
        return require(['../view/share/stamps/stamps'], resolve)
      },
      meta: {
        title: '邮册',
        keepAlive: false,
        auth: false
      }
    },
    {
      path: '/stampAlbum/stampAlbum',
      name: 'stampAlbum',
      component: resolve => {
        return require(['../view/share/stampAlbum/stampAlbum'], resolve)
      },
      meta: {
        title: '邮集单票详情',
        keepAlive: true,
        auth: false
      }
    },
    {
      path: '/shareDetail/shareDetail',
      name: 'shareDetail',
      component: resolve => {
        return require(['../view/share/shareDetail/shareDetail'], resolve)
      },
      meta: {
        title: '详情',
        keepAlive: true,
        auth: false
      }
    },
    {
      path: '/aboutWe/aboutWe',
      name: 'aboutWe',
      component: resolve => {
        return require(['../view/aboutWe/aboutWe'], resolve)
      },
      meta: {
        title: '关于我们',
        keepAlive: true,
        auth: false
      }
    },
    {
      path: '/scratchCard/index',
      name: 'ScratchCardIndex',
      meta: {
        title: '抽奖'
      },
      component: (resolve) => require(['@/view/ScratchCard/index'], resolve)
    },
    {
      path: '/stamps/read',
      name: 'stampsRead',
      component: (resolve) => require(['@/view/stamps/read'], resolve),
      meta: {
        title: '邮册翻阅',
        keepAlive: false,
        auth: false
      }
    },
    {
      path: '/stamps/list',
      name: 'stampsList',
      component: (resolve) => require(['@/view/stamps/list/list'], resolve),
      meta: {
        title: '邮册列表',
        keepAlive: false,
        auth: false
      }
    },
    {
      path: '/stamps/stampsNewHot',
      name: 'stampsNewHot',
      component: (resolve) => require(['../view/stamps/stampsNewHot/stampsNewHot'], resolve),
      meta: {
        title: '邮册',
        keepAlive: false,
        auth: false
      }
    },
    {
      path: '/stamps/stampDetail',
      name: 'stampDetail',
      component: (resolve) => require(['@/view/stamps/stampDetail/stampDetail'], resolve),
      meta: {
        title: '',
        keepAlive: false,
        auth: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js